/**
 * Возвращает текущий язык сайта
 * @returns {string}
 */
export default function getCurrentLang () {
	return document.documentElement.lang.split('-').pop().toLocaleLowerCase();
}



// WEBPACK FOOTER //
// ./_HTML/src/js/_utils/getCurrentLang.js